import { ROLES, type Role } from '@/lib/constants/roles';
import type { PersonaKey } from '@/lib/types/dashboard.types';

export function resolvePersonaKey(role: Role, tier: 'free' | 'paid'): PersonaKey {
  switch (role) {
    case ROLES.STARTUP_ADMIN:
      return tier === 'paid' ? 'premium_startup_admin' : 'free_startup_admin';
    case ROLES.STARTUP_MEMBER:
      return tier === 'paid' ? 'premium_startup_member' : 'startup_member';
    case ROLES.INVESTOR_ADMIN:
      return 'investor_admin';
    case ROLES.INVESTOR_MEMBER:
      return 'investor_member';
    case ROLES.TRUSTED_PARTNER_ADMIN:
    case ROLES.TRUSTED_PARTNER_MEMBER:
      return 'trusted_partner_member';
    case ROLES.SUPER_ADMIN:
      return 'super_admin';
    case ROLES.INDIVIDUAL:
    default:
      return 'individual';
  }
}
